import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { isDesktop } from "react-device-detect";

const BackgroundImage = props => {

    const { alt, urlAssets } = props;
    const backgroundImage = isDesktop ? 'background-desktop' : 'background-mobile'
    return (
        <article className="position-relative w-100 mx-auto">
            <LazyLoadImage
                alt={alt}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}img/${backgroundImage}.jpg`}
                wrapperClassName="w-100"
            />
        </article>
    )
}

export default BackgroundImage

BackgroundImage.propTypes = {
    alt: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired
}
